import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';

const request = createAppRequest();

export interface PortfolioCompanyDto {
  id: string;
  name: string;
  shortName: string;
  tagline: string;
  summary: string;
  fundId: string;
  fundUuid?: string | null;
  fundNameSnapshot?: string;
  industry: string;
  stage: string;
  city: string;
  investedAt: string;
  round: string;
  holding: number;
  valuation: number;
  bookValue: number;
  status: string;
  riskLevel: string;
  owner: string;
  latestUpdate: string;
  nextAction: string;
  reporting: string;
  favorite: boolean;
  sourceProjectId?: string;
}

export interface InvestmentRelationDto {
  id: string;
  companyId: string;
  fundId: string;
  fundUuid?: string;
  fundNameSnapshot?: string;
  round: string;
  amount: number;
  postValuation: number;
  holding: number;
  investedAt: string;
  boardSeat: string;
}

export const portfolioApi = {
  listCompanies: (options?: ApiRequestOptions) =>
    request<PortfolioCompanyDto[]>('/bff/portfolio/companies', options),

  listCompanyDocuments: (companyUuid: string) =>
    request<
      Array<{
        uuid: string;
        fileName: string;
        docType?: string;
        bizType: string;
        bizUuid: string;
        stageCategory: string;
        sourceLabel: string;
        remark?: string;
        sizeBytes?: number;
        createdAt?: string;
      }>
    >(`/bff/portfolio/companies/${companyUuid}/documents`),

  listDocumentCenter: (projectUuid: string) =>
    request<
      Array<{
        uuid: string;
        fileName: string;
        docType?: string;
        bizType: string;
        bizUuid: string;
        stageCategory: string;
        sourceLabel: string;
        remark?: string;
        sizeBytes?: number;
        createdAt?: string;
      }>
    >('/bff/investment/document-center', {
      method: 'GET',
      params: { projectUuid },
    }),
};
